const enableTracking = () => window._paq?.push(['setConsentGiven'])
const disableTracking = () => window._paq?.push(['forgetConsentGiven'])

export const setAnalytics = (active: boolean) => {
  if (active) {
    enableTracking()
  } else {
    disableTracking()
  }
}

export enum CustomDimensionEnum {
  ExposeFolderRecordID = 4,
  MobRecordID = 5,
  DocumentID = 6,
  DocumentBrandID = 9,
  ExposeFolderRecordType = 10,
}

const pushDimension = (type: CustomDimensionEnum, value: string) =>
  window._paq?.push(['setCustomDimension', type, value])

const deleteDimension = (type: CustomDimensionEnum) =>
  window._paq?.push(['deleteCustomDimension', type])

export const trackPage = () => {
  window._paq?.push([
    'setCustomUrl',
    `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
  ])
  window._paq?.push(['setDocumentTitle', document.title])
  window._paq?.push(['trackPageView'])
}

export const matomoTracking = (type: CustomDimensionEnum, value: string | null = null) => {
  if (!value) {
    deleteDimension(type)
  } else {
    pushDimension(type, value)
  }
}

export const TRACKING_VERSION = 1

export interface TrackingProps {
  prefix?: string
  piece?: string
}

export const getTrackingProps = (tracking?: TrackingProps) => {
  if (tracking === undefined || tracking.prefix === undefined || tracking.piece === undefined) {
    return {}
  }

  return JSON.parse(
    JSON.stringify({
      'data-track-content': '', // is fixed no need as variable or prop ;)
      'data-content-name': [
        TRACKING_VERSION,
        tracking.prefix,
      ]
        .filter(Boolean)
        .join(':'),
      'data-content-piece': tracking.piece,
    }),
  )
}
